export default __webpack_public_path__ + "static/media/front-shop.87c67897.png";